<template>
  <div class="dropdown">
    <a href="#" @click="() => expanded = !expanded">
      <i class="fa" :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </a>
    <input :indeterminate.prop="partial" :checked="selected" @change="toggleAll" type="checkbox" />
    <span>{{location.title}} ({{ ratioSelected.total }})</span>

    <div v-if="expanded">
      <div v-for="(type, i) in $consts.purchaseableNodeTypes" :key="'type-'+i" class="inset-1">
        <NodeTypeDropdown :location="location" :type="type" />
      </div>
    </div>
    <a v-else href="#" @click="() => expanded = true"><div class="inset-2">•••</div></a>
  </div>
</template>

<script>
import NodeTypeDropdown from "@/components/purchase/NodeTypeDropdown.vue";

export default {
  name: "location-dropdown",
  components: {
    NodeTypeDropdown
  },
  props: ["location"],
  data: () => ({
    expanded: true
  }),
  methods: {
    toggleAll() {
      var currentState = this.selected;

      for (let i = 0; i < this.$consts.purchaseableNodeTypes.length; i++) {
        let nodeType = this.$consts.purchaseableNodeTypes[i];
        let typeInt = this.$consts.NODE_TYPE_STR_TO_INT[nodeType];

        for (let j = 0; j < this.location.nodes[typeInt].length; j++) {
          let node = this.location.nodes[typeInt][j];
          node.selected = !currentState;
        }
      }
    }
  },
  computed: {
    ratioSelected() {
      let numSelected = 0;
      let numSeen = 0;
      for (let i = 0; i < this.$consts.purchaseableNodeTypes.length; i++) {
        let nodeType = this.$consts.purchaseableNodeTypes[i];
        let typeInt = this.$consts.NODE_TYPE_STR_TO_INT[nodeType];

        for (let j = 0; j < this.location.nodes[typeInt].length; j++) {
          let node = this.location.nodes[typeInt][j];
          if (node.selected) numSelected++;
          numSeen++;
        }
      }
      return { selected: numSelected, total: numSeen };
    },
    partial() {
      let ratio = this.ratioSelected;
      return ratio.selected > 0 && ratio.selected < ratio.total;
    },
    selected() {
      let ratio = this.ratioSelected;
      return ratio.selected === ratio.total;
    }
  }
};
</script>

<style lang="scss">
.dropdown {
  .inset-1 {
    margin-left: 40px;
  }
  .inset-2 {
    margin-left: 40px;
  }
}

.dropdown-fade-enter-active {
  transition: all 0.2s ease;
}
.dropdown-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: scale(0.95, 0.95);
}
</style>